import { PlatformEmailForm } from "./PlatformEmailForm";

export const CTASmall = ({ text }: { text: string }) => {
  return (
    <div className="flex flex-col gap-24 text-center md:px-32 md:text-left xl:px-64">
      <h4 className="text-18-24 font-bold text-black dark:text-white">
        {text}
      </h4>
      <div className="mx-auto flex max-w-lg md:mx-0">
        <PlatformEmailForm secondary />
      </div>
    </div>
  );
};
